import { render, staticRenderFns } from "./Pups.vue?vue&type=template&id=41dc80d5"
import script from "./Pups.vue?vue&type=script&lang=js"
export * from "./Pups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports